module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Aufgang")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Der Sonnenborn im Osten quillt"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsein blutig Wasser in die Nacht."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nZum weiten Himmelsbecken schwillt"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nes an in namenloser Pracht,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nbis endlich aus der Feuerflut"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndie Nymphe steigt in Liebesglut,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nvor der entweicht die schwarze Nacht,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndie Weltenpulse hüpfen macht,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nall ihre Glut und Liebeslust"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nausströmet in der Erde Brust.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2ce28d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0012.vue
// module id = 90
// module chunks = 0